// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__1X7WN","tab":"ProcedureTabs_tab__1ZzTb"};